import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeaturedSolutions, { AgilysysLogo } from '../components/FeaturedSolutions';

const A = '/assets/casino/solutions/';

const solutions = [
  { name: 'Guest App',            path: 'guest-app', screenshot: A + 'app-guest.png' },
  { name: 'Book',                 path: 'book',      screenshot: A + 'app-booking.png' },
  { name: 'Reserve',              path: 'reserve',   screenshot: A + 'app-reservations.png' },
  { name: 'Loyalty & Promotions', path: 'loyalty',   screenshot: A + 'app-membership.png' },
  { name: 'Digital Marketing',    path: 'marketing', screenshot: A + 'app-anniversary.png' },
];

function Engagement() {
  const navigate = useNavigate();
  return (
    <div className="page splash engagementPage">
      <div className="background" />
      <div className="page-header">Initial Engagement</div>
      <div className="text-blocks">
        <div className="std-text">Boosting new guest bookings and growing repeat guest revenue demands solutions that engage guests at every point in the decision process.{"\n\n"}</div>
        <div className="std-text">Optimize the new guest experience by providing an effortless reservation process that allows booking a single room or multiple rooms at once while attractively presenting all of the promotions, amenities and options your property has to offer.{"\n\n"}</div>
        <div className="std-text">Encourage repeat visits with personalized offers informed by past choices, stored preferences and profile information like birthdays and anniversaries.</div>
      </div>
      <FeaturedSolutions>
        {solutions.map((sol) => (
          <div key={sol.path} className="featured-item" onClick={() => navigate(`/solutions/${sol.path}`)}>
            <div className="item-head"><AgilysysLogo />{sol.name}</div>
            <img src={sol.screenshot} alt={sol.name} />
          </div>
        ))}
      </FeaturedSolutions>
    </div>
  );
}

export default Engagement;
